/**
 * Couleurs et symboles des planètes — référence centralisée
 * Reproduit les couleurs du site PHP original
 */

/** Couleur de fond du cercle de chaque planète */
export const PLANET_COLORS: Record<string, string> = {
  'Soleil': '#f59e0b',
  'Lune': '#9ca3af',
  'Mercure': '#06b6d4',
  'Vénus': '#ec4899',
  'Venus': '#ec4899',
  'Mars': '#ef4444',
  'Jupiter': '#f97316',
  'Saturne': '#1e40af',
  'Uranus': '#38bdf8',
  'Neptune': '#8b5cf6',
  'Pluton': '#991b1b',
  'Noeud Nord': '#059669',
  'Noeud Lunaire Nord': '#059669',
  'Noeud N.': '#059669',
  'Noeud N': '#059669',
  'Noeud Sud': '#7c3aed',
  'Noeud Lunaire Sud': '#7c3aed',
  'Noeud S.': '#7c3aed',
  'Noeud S': '#7c3aed',
  'Ascendant': '#c9a227',
  'AS': '#c9a227',
  'MC': '#c9a227',
  'Milieu du Ciel': '#c9a227',
  'Milieu de Ciel': '#c9a227',
};

/** Symboles Unicode des planètes */
export const PLANET_SYMBOLS: Record<string, string> = {
  'Soleil': '☉', 'Lune': '☽', 'Mercure': '☿',
  'Vénus': '♀', 'Venus': '♀', 'Mars': '♂',
  'Jupiter': '♃', 'Saturne': '♄', 'Uranus': '♅',
  'Neptune': '♆', 'Pluton': '♇',
  'Noeud Nord': '☊', 'Noeud Lunaire Nord': '☊',
  'Noeud N.': '☊', 'Noeud N': '☊',
  'Noeud Sud': '☋', 'Noeud Lunaire Sud': '☋',
  'Noeud S.': '☋', 'Noeud S': '☋',
  'Ascendant': 'AS', 'AS': 'AS',
  'MC': 'MC', 'Milieu du Ciel': 'MC', 'Milieu de Ciel': 'MC',
};

/** Symboles des signes */
export const SIGN_SYMBOLS: Record<string, string> = {
  'Bélier': '♈', 'Taureau': '♉', 'Gémeaux': '♊',
  'Cancer': '♋', 'Lion': '♌', 'Vierge': '♍',
  'Balance': '♎', 'Scorpion': '♏', 'Sagittaire': '♐',
  'Capricorne': '♑', 'Verseau': '♒', 'Poissons': '♓',
};

/** Symboles et couleurs des aspects */
export const ASPECT_INFO: Record<string, { symbol: string; color: string; nature: string }> = {
  'Conjonction':   { symbol: '☌', color: '#3b82f6', nature: 'Fusion' },
  'Opposition':    { symbol: '☍', color: '#ef4444', nature: 'Tension' },
  'Trigone':       { symbol: '△', color: '#22c55e', nature: 'Harmonie' },
  'Carré':         { symbol: '□', color: '#ef4444', nature: 'Tension' },
  'Sextile':       { symbol: '⚹', color: '#22c55e', nature: 'Harmonie' },
  'Quinconce':     { symbol: '⚻', color: '#f59e0b', nature: 'Tension' },
  'Semi-Carré':    { symbol: '∠', color: '#f59e0b', nature: 'Tension' },
  'Sesqui-Carré':  { symbol: '⊼', color: '#f59e0b', nature: 'Tension' },
  'Semi-Sextile':  { symbol: '⚺', color: '#22c55e', nature: 'Harmonie' },
};

/** Couleurs des éléments */
export const ELEMENT_COLORS: Record<string, string> = {
  'Feu': '#ef4444',
  'Terre': '#22c55e',
  'Air': '#eab308',
  'Eau': '#3b82f6',
};

/** Chiffres romains */
export const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
